import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import LoggingReactTable from "Components/LoggingReactTable";
import TextLimit from "Api/TextLimit";
import { usePushMessages } from "Api/Admin/PushMessages";

const PushMessagesTable = () => {
	const [pageSizeCount, setPageSizeCount] = useState(20);
	const [pageNumber, setPageNumber] = useState(1);
	const [searchValue, setSearchValue] = useState("");

	const {
		data: response,
		isLoading,
	} = usePushMessages(
		pageSizeCount,
		pageNumber,
		searchValue
	);

	const data = response?.data || [];
	const totalPageCount = response?.meta?.last_page || 0;
	const totalCount=response?.meta?.total;


	const paginate = (val) => {
		setPageNumber(val);
	};

	const handleInputChange = (val) => {
		setPageNumber(1);
		setSearchValue(val);
	};

	const filterList = (val) => {
		handleInputChange(val);
	};

	const indexPageSize = (val) => {
		setPageSizeCount(val);
	};

	const loggingTablePageSize = (val) => {
		setPageNumber(1);
		indexPageSize(val);
	};

	const columns = [
		{
			header: "Datum-tijd",
			accessorKey: "date",
		},
		{
			header: "Ontvanger - Id-Ontvanger",
			accessorKey: "vRecipientFullName",
			cell: (value) =>
				`${value.row.original.recipientLastName} ${value.row.original.recipientFirstName} - ${value.row.original.recipientId}`
		},

		{
			header: "Verzender - Id-verzender",
			accessorKey: "vSenderFullName",
			cell: (value) =>
				`${value.row.original.senderLastName} ${value.row.original.senderFirstName} - ${value.row.original.senderId}`
		},
		{
			header: "Verzoek-id",
			accessorKey: "substitutionId",
		},
		{
			header: "Firebase response-id",
			accessorKey: "firebaseResponse",
		},
	];

	return (
		<>
			<LoggingReactTable
				data={data}
				columns={columns}
				setPageNumber={setPageNumber}
				pageNumber={pageNumber}
				totalPageCount={totalPageCount}
				paginate={paginate}
				filterList={filterList}
				loggingTablePageSize={loggingTablePageSize}
				pageSizeCount={pageSizeCount}
				showLoader={isLoading}
				totalCount={totalCount}
				tableClassName="mb-0 table table-borderless table-sm table-hover table-heading-style"
			/>
		</>
	);
};

export default PushMessagesTable;
